import { createAction } from '@reduxjs/toolkit';

const saveJourneyFormValues = createAction('ui/sealink/journey/saveFormValues');
const setJourneyDates = createAction('ui/sealink/journey/setJourneyDates');
const setJourneys = createAction('ui/sealink/journey/setJourneys');
const setSegmentStop = createAction(
  'ui/sealink/journey/setSegmentStop',
  (segmentId, journeyIndex, segmentStop) => ({
    payload: {
      segmentId,
      journeyIndex,
      segmentStop,
    },
  })
);

export { saveJourneyFormValues, setJourneyDates, setJourneys, setSegmentStop };
